import React from "react";

import SurveyCard from "./Survey/SurveyCard";
import ThisTheme from "../../../themes/MSFTheme";


function MSFWidget () {

    return (
        <React.Fragment>
            <SurveyCard theme={ThisTheme}/>
        </React.Fragment>
    );
}

export default MSFWidget;
